let _userInfo = {};

export function getUserInfo() {
  return _userInfo;
}

export function setUserInfo(userInfo) {
  _userInfo = userInfo;
}

export function isFecAdmin() {
  return !!(_userInfo && _userInfo.is_fec_admin === true);
}
